module.exports = __webpack_public_path__ + "img/img-intro1.87cd33f7.jpg";